import React from "react";
import "./loaderCard.scss";
import classNames from "classnames";

interface IProps {
  /**Additional styling such as adjusting the width and height (ex: {width: 200px; height: 100%}) */
  customCSSProperties?: React.CSSProperties;
  /**The number of rows of loading text */
  textRows?: number;
  /**Spacing between text rows in px*/
  textRowSpacing?: number;
  /**Determines if a circlular loading image is displayed */
  image?: boolean;
  /** Determine if square border appears*/
  borderless?: boolean;
}

export default function LoaderCard(props: IProps) {
  const { customCSSProperties, textRows, image, textRowSpacing, borderless } = props;

  return (
    <div
      style={customCSSProperties}
      className={classNames("loader-card", {
        borderless: borderless,
      })}
    >
      {image && (
        <div
          className={classNames({
            "loader-card-image": !borderless,
            "loader-card-image-borderless": borderless,
          })}
        />
      )}
      {textRows !== undefined && (
        <div className="loader-card-text-container" style={{ gap: textRowSpacing ? `${textRowSpacing}px` : undefined }}>
          {Array.from(new Array(textRows))?.map((row, index) => (
            <div key={index} className="loader-card-text"></div>
          ))}
        </div>
      )}
    </div>
  );
}
